import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DownloadService } from './services/download.service';



@NgModule({
	declarations: [],
	imports: [
		CommonModule
	],
	providers: [DownloadService]
})
export class DownloadModule { }
